module.exports = __webpack_public_path__ + "static/media/kelahiran.fe7c0471.png";